import { css } from '@emotion/react'

export const text = css`
  letter-spacing: -0.01em;
  grid-area: subtitle;
  justify-self: start;
  text-align: start;
`
